import React, { Component } from "react";
import Translations from "../../services/translation.service";
import FirebaseAnalytics from "../../services/analytics.service";
import FieldValidity from "../../services/fieldValidity.service";
import User from "../../services/user.service";
import StorefrontTitle from "../shared/storefront-title.component";
import SelectionCard from "./selectionCard";
import hintImg from "../../assets/img/hint.svg";
import CountrySelectBasic from "../shared/count-select-basic.component";
import EligibityFormSkeleton from "../skeleton/eligibity-form.component";
import FetchNationalitySkeleton from "../skeleton/eligibilty-fetch-nationality.component";
import SpinnerTimeLoader from "../shared/timeLoading";
import Helpers from "../../helpers/shared.helper";
import ContentSlider from "../shared/contentSlider";
import ModalWrapper from "../shared/modal-wrapper";
import Settings from "../../services/settings.service";
import Storage from "../../services/storage.service";


class EligibityForm extends Component {
  subscriptions = [];

  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      agreeDataTerms: false,
      agreeCreditScore: false,
    };
  }

  componentDidMount() {
    this.props.toggleLoading(true);
    User.getFlowStatus()
      .then((response) => {
        if (response.data?.flow_status_flags?.Tahaqoq_Reached_max_number_of_retries) {
          this.props.action("EligibilityFailedFinal");
          this.props.toggleLoading(false);
        } else {
          this.props.toggleLoading(false);
        }
      })
      .catch((error) => {
        this.props.toggleLoading(true);
      });
  }

  handleModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      openModal: !this.state.openModal
    })
    FirebaseAnalytics.about_credit_score_info();
  };

  handleTermsChecked = () => {
    // For Postpaid
    if(Helpers.isPlanPostPaidByPC()) {
      if(this.state.agreeDataTerms && this.state.agreeCreditScore) {
        return false;
      } else {
        return true;
      }
    } else {
      // For Plans except Postpaid
      if (this.state.agreeDataTerms) {
        return false;
      } else {
        return true;
      }
    }
  }

  staticLanguageLink = (link, linkAR) => {
    if (Translations.activeLang === "en") {
        return link;
    }
    if (Translations.activeLang === "ar") {
        return linkAR;
    }
    return "#";
  };

  getSliderData = () => {
    const poModalKey = `credit_score_popup_json`;
    let business = Storage.get("business", true);
    let poModalData = null;
    if (business) {
      business = JSON.parse(business);
      if(business[poModalKey]) {
        poModalData = business[poModalKey]
      }
    }
    return poModalData
  }

  render() {
    let prefix = "scr_3.3.1_Check_Eligibility_";
    let prefix4 = "stm_eligibility_";

    let stfidType = null;
    if (this.props.state.idType) {
      stfidType = this.props.state.idType.map(option => {
        return (
          <SelectionCard
            key={option.Id}
            keyID={option.Id}
            card={option}
            selectedCard={this.props.state.selectedIdType}
            handleSelectedCard={this.props.updateIdType}
          />
        );
      });
    }

    let availableNationalities = null;
    if (this.props.state.availableNationalities) {
      availableNationalities = this.props.state.availableNationalities.map(
        (option, index) => {
          return (
            <option key={index} value={option.Id} selected={this.props.state.selectedFromIDType}>
              {option.Nationality}
            </option>
          );
        }
      );
      availableNationalities.unshift(
        <option key="1_1" value={0} hidden>
          {Translations.keys[prefix + "choose_nationality"]}
        </option>
      );
    }

    let availableSaudiCities = null;
    if (this.props.state.availableSaudiCities) {
      availableSaudiCities = this.props.state.availableSaudiCities.map(
        option => {
          return (
            <option key={option.City} value={option.Id}>
              {option.City}
            </option>
          );
        }
      );
      availableSaudiCities.unshift(
        <option key="1_1" value={0} className="placeholder" hidden>
          {Translations.keys[prefix + "choose_cities"]}
        </option>
      );
    }

    let fetchedNationality = null;

    if (this.props.selectedNationalityId) {
      fetchedNationality = (
        <div className="field-container">
          <label>{Translations.keys[prefix4 + "nationality"]}</label>
          <select
            className="storefront-search-input select-component"
            name="Nationality"
            onChange={this.props.updateNationality}
          >
            {availableNationalities}
          </select>
        </div>
      );
    } else {
      if (this.props.state.fetchedNationalityFirstTime) {
        if (this.props.state.fetchingNationality) {
          fetchedNationality = <FetchNationalitySkeleton />;
        } else {
          fetchedNationality = (
            <div className="field-container">
              <label>{Translations.keys[prefix4 + "nationality"]}</label>
              <select
                className={`storefront-search-input select-component ${this.props.selectedNationalityId ?? "placeholder"}`}
                name="Nationality"
                onChange={this.props.updateNationality}
              >
                {availableNationalities}
              </select>
            </div>
          );
        }
      }
    }

    let content = (
      <>
        <div className="eligibility-form-container">
          <StorefrontTitle
            title={Translations.keys[prefix4 + "check_eligibility"]}
            desc={Translations.keys[prefix4 + "quick_check"]}
          />
          <div className="selection-card-container storefront-scrollbar-hide">
            {stfidType}
          </div>
          <div className="field-section">
            <div className="field-container">
              <label>{Translations.keys[prefix4 + "id_number"]}</label>
              <input
                className={
                  "storefront-search-input " +
                  (!this.props.state.iDTouched || (this.props.state.iDTouched && this.props.state.iDValid)
                    ? "valid"
                    : "invalid") +
                  (this.props.state.id_number ? " filled" : "")
                }
                autoComplete="off"
                type="number"
                name="id_number"
                ref="id_number"
                id="id_number"
                require="true"
                placeholder={Translations.keys[prefix4 + "id_number"]}
                value={this.props.id_number}
                onChange={this.props.updateIdNumber}
              />
              <div className="hint-section">
                <img src={hintImg} alt="Message" />
                <p>{Translations.keys[prefix4 + "id_number_hint"]}</p>
              </div>
            </div>
            {fetchedNationality}
            <div className="field-container">
              <label>{Translations.keys[prefix4 + "residence"]}</label>
              <select className={`${this.props.selectedCityId ?? "placeholder"} storefront-search-input select-component`} 
              name="city" 
              onChange={this.props.updateCity}
              placeholder={Translations.keys[prefix4 + "choose_nationality"]}
              >
                {availableSaudiCities}

              </select>
            </div>
            {this.props?.showPhone ?
              <div className="field-container">
                <label>{Translations.keys[prefix4 + "phone_number"]}</label>
                <div
                  className="storefront-two-fields"
                >
                  {this.props?.countryDisabled ?
                    <div className="country-select-container">
                      <CountrySelectBasic
                        defaultCountry={this.props.phoneCode.value}
                        disabled
                      />
                    </div>
                    :
                    null
                  }
                  {!this.props?.countryDisabled ?
                    <div
                      className="country-select-container"
                    >
                      <CountrySelectBasic
                        form_id={'country_contact_user'}
                        field_name="country_select"
                        defaultCountry={this.props.phoneCode.value}
                        updateFieled={this.props.handleCountryCode}
                      />
                    </div>
                    :
                    null
                  }
                  <input
                    type="tel"
                    className={
                      "storefront-search-input " +
                      (!this.props.state.phone.touched || (this.props.state.phone.touched && this.props.state.phone.valid)
                        ? "valid"
                        : "invalid") +
                      (this.props.state.phone.value ? " filled" : "")
                    }
                    name="contact_number"
                    id="contact_number"
                    value={this.props.state.phone.value}
                    onChange={event => {
                      if(event.target.value === "0") {
                        return;
                      }
                      if (FieldValidity.inputDigits(event, 10)) {
                        this.props.updateContactField(event, "form", 'phone')
                      }
                    }}
                    placeholder={Translations.keys["stm_search_input_placeholder"]}
                  />
                </div>
                <div className="hint-section">
                  <img src={hintImg} alt="Message" />
                  <p>{Translations.keys["3.3.2.B_enter_associated_num"]}</p>
                </div>
                {/* {
              !this.props.state.phone.valid ? <span className="error-msg">{this.props.state.phone?.error}</span> : null
            } */}
              </div> : null}
            
            <div className="eligibility-checkbox-container">
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  name="agreeDataTerms"
                  id="agreeDataTerms"
                  checked={this.state.agreeDataTerms}
                  onChange={(event)=>{
                    this.setState({
                      agreeDataTerms: event.target.checked
                    })
                  }}
                />
                <label htmlFor="agreeDataTerms">{Translations.keys["stm_eligibility_term_agree"]}{" "}<a href={this.staticLanguageLink(Settings?.footer?.terms_and_conditions, Settings?.footer?.terms_and_conditionsAR)} target="_blank" rel="noopener noreferrer">{Translations.keys["stm_eligibility_term_learn_more"]}</a></label>
              </div>
              {Helpers.isPlanPostPaidByPC() ?
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    name="agreeCreditScore"
                    id="agreeCreditScore"
                    checked={this.state.agreeCreditScore}
                    onChange={(event)=>{
                      this.setState({
                        agreeCreditScore: event.target.checked
                      })
                    }}
                  />
                  <label htmlFor="agreeCreditScore">{Translations.keys["stm_eligibility_credit_score_agree"]}{" "}<span onClick={this.handleModal}>{Translations.keys["stm_eligibility_credit_score"]}</span></label>
                </div>
              : null}
            </div>

            <button
              className={"common-button"}
              disabled={!this.props.state.formValid || !this.props.state.iDValid || this.handleTermsChecked()}
              onClick={() => {
                FirebaseAnalytics.button_clicked(prefix + "btn_label")
                this.props.checkEligibilityRoot();
              }}
            >
              {Translations.keys[prefix4 + "check"]}
            </button>
          </div>
        </div>
        {this.state.openModal && 
          <ModalWrapper handleToggleModal={this.handleModal}>
            <ContentSlider
              imagesFolder="information_popup_images"
              sliderData={this.getSliderData()}
              closeModal={this.handleModal} 
            />
          </ModalWrapper>
        }
      </>
    );
    if (this.props.state.loading || !this.props.state.basic_data_loaded) {
      content = <EligibityFormSkeleton />;
    }
    if (this.props.state.actionLoading) {
      content = <SpinnerTimeLoader />;
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

export default EligibityForm;